import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import { Impressum, Datenschutz } from "@/pages/Legal";
import { useLenis } from "@/hooks/useLenis";

function Shell() {
  useLenis();
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/leistungen/:slug" element={<ServiceDetail />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
      <Footer />
      <WhatsAppFab />
      <Toaster position="top-center" theme="dark" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}
